<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.43646 3C7.43646 2.44772 7.88418 2 8.43646 2H15.5607C16.1129 2 16.5607 2.44772 16.5607 3C16.5607 3.55228 16.1129 4 15.5607 4H8.43646C7.88418 4 7.43646 3.55228 7.43646 3ZM4.6817 6.378C4.6817 5.82572 5.12942 5.378 5.6817 5.378H18.3157C18.8679 5.378 19.3157 5.82572 19.3157 6.378C19.3157 6.93028 18.8679 7.378 18.3157 7.378H5.6817C5.12942 7.378 4.6817 6.93028 4.6817 6.378ZM5.55402 11.2344C4.68115 11.2344 4.04614 12.0634 4.27377 12.9067L5.92328 19.0186C6.07956 19.5974 6.60497 19.9997 7.20454 19.9997H16.7945C17.3936 19.9997 17.9184 19.5979 18.0747 19.0186L19.7253 12.9067C19.9528 12.0638 19.3181 11.2344 18.4441 11.2344H5.55402ZM2.34287 13.4278C1.77231 11.3141 3.36396 9.23438 5.55402 9.23438H18.4441C20.6347 9.23438 22.2269 11.3138 21.6562 13.4279L20.0056 19.5397C19.6139 20.991 18.298 21.9997 16.7945 21.9997H7.20454C5.70146 21.9997 4.3843 20.9915 3.9924 19.5398L2.34287 13.4278Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
